<template>
    <ion-row class="container ion-align-items-center ion-justify-content-center" style="margin-top: -1px">
        <ion-col size="6" size-md="3" class="ion-align-items-center ion-text-center">
            <ion-img alt="Donatos Rewards Logo" :src="require('@/assets/donatos-rewards-logo-light.svg')" style="max-width: 250px; margin: auto" />
        </ion-col>
        <ion-col size="6" size-md="3" class="ion-align-items-center ion-text-center">
            <ion-row class="ion-justify-content-center pb-8">
                <ion-button
                    class="interstate-bold join-now-btn"
                    :class="'join-now-btn' + orientation"
                    mode="md"
                    color="light"
                    :size="buttonSize"
                    fill="outline"
                    @click="() => router.replace('/signup')"
                >
                    Join Now
                </ion-button>
            </ion-row>
            <ion-row class="ion-justify-content-center" :class="'sign-in-cta' + orientation">
                <span>Already a Member?&nbsp;</span>
                <ion-nav-link class="sign-in-btn" @click="() => router.replace('/login')">Sign in </ion-nav-link>
            </ion-row>
        </ion-col>
    </ion-row>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { IonRow, IonCol, IonButton, IonNavLink, IonImg } from '@ionic/vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default defineComponent({
    components: { IonRow, IonCol, IonButton, IonNavLink, IonImg },
    setup() {
        const router = useRouter();
        const store = useStore();

        const buttonSize = computed(() => (store.getters.isPortraitOrientation ? 'default' : 'large'));
        const orientation = computed(() => (store.getters.isPortraitOrientation ? '' : '-desktop'));

        return {
            router,
            buttonSize,
            orientation,
        };
    },
});
</script>

<style scoped>
.container {
    color: var(--ion-color-light);
    background-color: var(--ion-color-light-contrast);
    padding: 20px;
}

.sign-in-btn {
    color: var(ion-color-light) !important;
    font-weight: bold;
    cursor: pointer;
}

/* sign-in-cta and sign-in-cta-desktop are set by a computed prop */
.sign-in-cta {
    font-size: calc(10px + 0.2em);
}

.sign-in-cta-desktop {
    font-size: calc(14px + 0.2em);
}

.join-now-btn {
    width: 90%;
    min-width: 155px;
    color: white;
}

.join-now-btn-desktop {
    width: 75%;
    min-width: 200px;
}
</style>
